import { cleanMarkdownText } from "@/lib/markdown-utils";
import { UnifiedMarkdownRenderer } from "@/components/ui/unified-markdown-renderer";
import { useTranslation } from "react-i18next";

interface TranscriptTabProps {
  transcriptText: string | null;
  fileName: string;
  hideActions?: boolean;
}

export const TranscriptTab = ({ transcriptText, fileName, hideActions = false }: TranscriptTabProps) => {
  const { t } = useTranslation();
  const cleanedText = cleanMarkdownText(transcriptText);

  return (
    <>
      {cleanedText ? (
        <div className="w-full max-w-none">
          <UnifiedMarkdownRenderer
            value={cleanedText}
            mode="view"
            readOnly={true}
            height={400}
            className="border-none shadow-none"
          />
        </div>
      ) : (
        <div className="text-muted-foreground italic bg-muted/30 p-4 rounded-md text-center">
          {t('records.transcript.no_content')}
        </div>
      )}
    </>
  );
};
